import theme from './theme';

export default {
  colors: {
    ...theme.colors,
    primary: '#17b70f',
    primary_light: 'rgba(23, 183, 15, 0.2)',
    red_light: '#fe787839',
    dark_shadow: 'rgba(0,0,0,0.5)',
    sutil_shadow: 'rgba(0,0,0,0.08)',
    carousel_dot_active: '#17b70f',
    carousel_dot_inactive: 'rgba(0, 0, 0, 0.1)',
    profile_background: '#FFF',
    profile_initials: '#222',
    profile_background_reverse: '#222',
    profile_initials_reverse: '#FFF',
    header_icon_background: 'rgba(0, 0, 0, 0.044)',
    header_icon_color: '#222',
    button_secondary: '#F2F2F0',
    card_menu_active: '#E7F8E7',
    home_services_fuel_bg: '#E7F8E7',
    home_services_fuel_pulse: '#17b70f',
    home_services_vantagens_bg: 'rgba(212, 175, 55, 0.12)',
    home_services_vantagens_icon: '#C89B1F',
    home_services_vantagens_text: '#2B2B2B',
    home_services_vantagens_border: '#C89B1F',
    home_services_vantagens_gradient: ['#FFFDF6', '#FFF6DF', '#FFECC0', '#FFF9EA'],
    info_bg: 'rgba(56, 138, 221, 0.10)',
    info_icon: '#377ACD',
    achievements_bg: '#ffb11539',
    achievements_color: '#FFB115',
    coupon_card_border: 'rgba(22, 163, 74, 0.22)',
    coupon_card_shadow: 'rgba(22, 163, 74, 0.08)',
    coupon_card_shadow_ios: 'rgba(148, 225, 197, 0.25)',
    carrinho_progress_border: 'rgba(255, 149, 20, 0.35)',
    carrinho_progress_shadow: 'rgba(255, 149, 0, 0.3)',


    coupon_gold_gradient: ['#FFFDF6', '#FFFDF6', '#FFFDF6', '#FFFDF6'],
    coupon_silver_gradient: ['#FCFCFD', '#FCFCFD', '#FCFCFD', '#FCFCFD'],
    coupon_category_ouro_border: '#eec84a64',
    coupon_category_ouro_icon: '#C99C39',
    coupon_category_ouro_action_bg: '#eec84a',
    coupon_category_ouro_action_text: '#FFF',
    coupon_category_prata_border: '#BBC3CA',
    coupon_category_prata_icon: '#9EA7AD',
    coupon_category_prata_action_bg: '#9EA7AD',
    coupon_category_prata_action_text: '#fff',
    coupon_category_default_border: '#E87722',
    coupon_category_default_icon: '#E87722',
    coupon_category_default_action_bg: '#17B70F',
    coupon_category_default_action_text: '#FFF',

    coupon_badge_ouro_bg: '#FFFDF6',
    coupon_badge_ouro_text: '#eec84a',
    coupon_badge_ouro_border: '#eec84a',
    coupon_badge_prata_bg: '#E7E8EB',
    coupon_badge_prata_text: '#80868E',
    coupon_badge_prata_border: '#BBC3CA',

  },

  fonts: {
    light: 'Poppins-Light',
    regular: 'Poppins-Regular',
    medium: 'Poppins-Medium',
    semibold: 'Poppins-SemiBold',
    bold: 'Poppins-Bold',
    fuel: 'OpenSans-ExtraBoldItalic',
  },

  mapstyle: [
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
  ],
};
